/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';
import {
    ResendOtpRequest,
    ResendOtpResponse,
    SetUserPasswordPayload,
    SetUserPasswordResponse,
    SignUpRequest,
    SignUpResponse,
    VerifyRegistrationOtpRequest,
    VerifyRegistrationOtpResponse,
} from '../pages/registration/registration-types';

export interface ApiResponse {
    statusCode: number;
    data: any[];
    message?: string;
}

// api to register user and get passcode
export const signUpUser = async (inputPayload: SignUpRequest, showLoader: boolean = true): Promise<SignUpResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.Register,
            payLoad: inputPayload,
            showLoader: showLoader,
        });

        return response?.data;
    } catch (error: any) {
        console.error('Error signing up user:', error);
        // Interceptor may reject with response body; raw axios errors nest payload under response.data
        const body = error?.response?.data ?? error;
        return body;
    }
};

// api to resend passcode
export const resendOtp = async (
    inputPayload: ResendOtpRequest,
    showLoader: boolean = true,
): Promise<ResendOtpResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.ResendOtp,
            payLoad: inputPayload,
            showLoader: showLoader,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error resending Passcode:', error);
        return error;
    }
};
export const verifyRegistrationOtp = async (
    inputPayload: VerifyRegistrationOtpRequest,
    showLoader: boolean = true,
): Promise<VerifyRegistrationOtpResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.VerifyRegistrationOtp,
            showLoader: showLoader,
            payLoad: inputPayload,
        });

        return response?.data;
    } catch (error: any) {
        console.error('Error verifying registration Passcode:', error);
        throw error;
    }
};

export const setUserPassword = async (
    inputPayload: SetUserPasswordPayload,
    showLoader: boolean = true,
): Promise<SetUserPasswordResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.SetUserPassword,
            showLoader: showLoader,
            payLoad: inputPayload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error creating password:', error);
        throw error;
    }
};

export const registrationSecurityCheck = async (
    inputPayload: any,
    showLoader: boolean = true,
): Promise<ApiResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.RegistrationSecurityCheck,
            showLoader: showLoader,
            payLoad: inputPayload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error in registration security check:', error);
        throw error;
    }
};

export const submitNewUserDetails = async (inputPayload: any, showLoader: boolean = true): Promise<ApiResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.VerifyRegistrationFormDetails,
            showLoader: showLoader,
            payLoad: inputPayload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error in registration security check:', error);
        throw error;
    }
};
